const Arrow = ({ fill, stroke, className }: Props) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="56"
      fill="none"
      viewBox="0 0 32 56"
    >
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M1.538 39.219l14.545 14.546 14.546-14.546"
      ></path>
      <path
        fill={fill}
        d="M16.734 52.946V1.928a.928.928 0 10-1.855 0v51.018a.928.928 0 001.855 0z"
      ></path>
      <path
        stroke={stroke}
        d="M16.27 52.944V1.923a.464.464 0 10-.928 0v51.02a.464.464 0 10.928 0z"
      ></path>
    </svg>
  );
};

interface Props {
  fill?: string;
  stroke?: string;
  className?: string;
}

export default Arrow;
